import 'select2'
import 'bootstrap/js/modal'

import langDe from 'select2/src/js/select2/i18n/de'

function ensureFixedEmailDomain (event) {
  const emailInput = event.currentTarget
  const emailDomain = emailInput.dataset.bankEmailDomain
  const emailValue = emailInput.value

  if (!emailValue.endsWith(emailDomain)) {
    event.preventDefault()
    emailInput.value = emailDomain
  }
}

function handleBankSelect (event) {
  const { bankEmailDomain, selfRegistration } = event.params.data
  const emailDomain = `@${bankEmailDomain}`
  const form = $(event.currentTarget).closest('form')
  const emailField = form.find('input[type=email')
  const submit = form.find('button[type=submit]')

  // Based on selection fill in email value and data attributes
  emailField.val(emailDomain)
  emailField.attr('data-bank-email-domain', emailDomain)
  emailField.attr('data-self-registration', selfRegistration)

  // Change submit button label
  if (selfRegistration === false) {
    submit.html('Interesse bekunden')
  } else {
    submit.html('Ihre Bank anmelden')
  }
}

$(document).ready(() => {
  if ($('.bank_select').length === 0) {
    return
  }

  $('.bank_select').select2({
    placeholder: 'Suchen Sie Ihre Bank',
    language: langDe,
    allowClear: true,
    minimumResultsForSearch: -1,
    minimumInputLength: 3,
    dropdownAutoWidth: true,
    theme: ' vr-banken__form-input__field vr-banken__form-input__select',
    width: '100%',
    ajax: {
      url: '/api/bank-subsidiary-search-by-name',
      dataType: 'json',
      delay: 250,
      data (params) {
        return {
          query: params.term,
        }
      },
      processResults (data) {
        return {
          results: data.map(bank => (
            {
              id: bank.bank_code,
              text: bank.name,
              bankEmailDomain: bank.bank_email_domain,
              selfRegistration: bank.self_registration,
            }
          )),
        }
      },
    },

  }).on('select2:select', handleBankSelect)

  $('input[type=email').on('keyup blur', ensureFixedEmailDomain)
})
